import React from 'react'
import { Button, Flex, Result } from 'antd'
import { useNavigate } from 'react-router-dom'

export const ForbiddenPage: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Flex justify="center" align="center" style={{ minHeight: 400 }}>
      <Result
        status="403"
        title="403"
        subTitle="You do not have access to this page."
        extra={
          <Button type="primary" onClick={() => navigate('/')}>
            Go to available pages
          </Button>
        }
      />
    </Flex>
  )
}
